module.exports = __webpack_public_path__ + "img/cross1green.b23aaba4.png";